/**
 * Item 4 (front-desk quick wins, C2 — 2026-09-21): the WS `location`
 * role's edit surface.
 *
 * The ticket names a SPECIFIC group of fields for the front desk, and the
 * live code admitted the role to the whole editable whitelist. This is a
 * deliberate ACCESS REDUCTION: outside this group the pencil is not
 * rendered for `location`, and the server answers 403 with zero writes
 * (`crm_router.LOCATION_EDITABLE_FIELDS` — the same list, pinned equal).
 *
 * Sales and admin are unaffected: this list is consulted only when the
 * acting user's role is `location`.
 *
 * The ticket also names a SECOND PHONE and PREFERRED LANGUAGE. Neither
 * exists in this portal (no column, no sync projection, no card field) —
 * see the receipts; they are absent here for the same reason.
 */
export const LOCATION_EDITABLE_FIELDS = [
  "phone",
  "email",
  "patient_address",
  "patient_city",
  "patient_state",
  "patient_zip_code",
  "date_of_birth",
];

export function canLocationRoleEdit(fieldName) {
  return LOCATION_EDITABLE_FIELDS.includes(fieldName);
}
